const FabricationStage = `
  id
  name
`;

export default FabricationStage;
